import { previewLabel, usePreview } from "@/lib/preview";

/**
 * A rail across the very top of the window for as long as a preview lasts, on
 * every page and above dialogs (the preview changes what everything shows, so
 * nothing should look normal). It is fixed: it stays put when the page scrolls.
 * The top-bar chip names who is previewed; this is what is always in view, and
 * what tells screen readers.
 */
export function PreviewRail() {
  const preview = usePreview();
  if (!preview) return null;
  return (
    <>
      <div
        data-preview-rail
        aria-hidden
        className="pointer-events-none fixed inset-x-0 top-0 z-100 h-1 bg-status-warn"
      />
      <p role="status" className="sr-only">
        Previewing as {previewLabel(preview)}. Read only.
      </p>
    </>
  );
}
